import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { isNil } from 'lodash';
import { concatMap, filter, Observable, of, Subject, switchMap, takeUntil } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Injectable({ providedIn: 'root' })
export class CanActivateGuard implements CanActivate {

  constructor(private msalService: MsalService,
    private authService: AuthService,
    private router: Router,
    private msalBroadcastService: MsalBroadcastService) { }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        switchMap(() => {

          if (isNil(this.authService.getCurrentAD)) {
            if (state.url !== '/' && state.url !== '/login') {
              localStorage.setItem("SCGChem.PMM.RFQ.WebCli.postLoginUrl", window.location.href);
            }
            this.router.navigate(['/login']);
          }

          if (!isNil(this.authService.getCurrentAD) && this.msalService.instance.getAllAccounts().length == 0) {
            if (state.url !== '/' && state.url !== '/login') {
              localStorage.setItem("SCGChem.PMM.RFQ.WebCli.postLoginUrl", window.location.href);
            }
            this.msalService.loginRedirect();
          }
          else {
            return of(true);
          }

          return of(false);
        })
      );
  }
}